import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/presentation/")({
  loader: () => {
    throw redirect({
      to: "/dashboard/presentation/new/select-subject",
    });
  },
});
